<template>
  <v-navigation-drawer
    app
    v-model="gptDrawer"
    right
    temporary
    fixed
    height="100%"
    :width="drawerWidth"
    class="Fero-GPT-Drawer"
  >
    <div class="Fero-GPT-Drawer__header d-flex align-center px-4">
      <img :src="gptLogo" alt="" width="28" height="28" class="mr-2" />
      <span class="text-h6" style="color: #0e5e6d">Fero GPT</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="gptDrawer = false">
        <v-icon style="color: #0e5e6d">mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="Fero-GPT-Drawer__body">
      <div v-if="error" class="Fero-GPT-Drawer__error">
        <v-icon size="64" color="error">mdi-alert-circle-outline</v-icon>
        <p class="mt-4 text-center">{{ error }}</p>
      </div>
      <iframe
        v-else-if="embedUrl"
        :src="embedUrl"
        title="Fero GPT"
        referrerpolicy="strict-origin-when-cross-origin"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
        style="display: block; border: 0; width: 100%; height: 100%"
      />
    </div>
  </v-navigation-drawer>
</template>

<script>
import gptLogo from "@/assets/images/logos/fero-gpt.svg";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    embedUrl: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      gptLogo,
    };
  },
  computed: {
    gptDrawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    drawerWidth() {
      if (typeof window === "undefined") return 1500;
      return Math.min(1500, window.innerWidth * 0.9);
    },
  },
};
</script>

<style scoped>
.Fero-GPT-Drawer {
  display: flex;
  flex-direction: column;
}
.Fero-GPT-Drawer__header {
  height: 56px;
  min-height: 56px;
  background: #ffffff;
  border-bottom: 2px solid #17b7d0;
}
.Fero-GPT-Drawer__body {
  flex: 1 1 auto;
  height: calc(100% - 56px);
}
.Fero-GPT-Drawer__error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
}
</style>
